import React from "react";
import img5 from '../../images/image5.png';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const HeroHeader = () => {
  let history = useHistory();
  
  const goToLanding=()=>history.push("/");

  const logInResponse=useSelector(state=>state.loginReducer);

  const dispatch=useDispatch();

  const openLoginModal=(e)=>{
    e.preventDefault();
    dispatch({type:"LOGIN_MODAL_OPEN"});
}

  return (
    <>
      <div className="header">
        <div className="header-section-box header-text-box">
          <div className="header-text">
            <h1 className="header-heading">A veterinary gut check in your pocket</h1>
            <div className="header-blue-line"></div>
            <p className="header-para">We have the tools to make you feel confident in your decisions.</p>
          </div>
          <div className="button-pair">
            <button className={`button signup-button ${logInResponse.isLoggedIn?"signup-button-fullwidth":null}`} onClick={() => goToLanding()}>Explore More</button>
            {logInResponse.isLoggedIn?null:<button className="button login-button" onClick={openLoginModal}>Log in</button>}
          </div>
        </div>
        <div className="header-section-box header-img">
          <img src={img5} alt=""/>
        </div>
        <div className="mobile-button-pair">
          <button className="button signup-button" onClick={() => goToLanding()}>Explore More</button>
          {logInResponse.isLoggedIn?null:<button className="button login-button" onClick={openLoginModal}>Log in</button>}
        </div>
      </div>
    </>
  );
};

export default HeroHeader;
